import React from 'react'
import { IconButton } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid'

import { VisibilityRounded as Details } from '@mui/icons-material'

export type ColumnAction = 'Edit' | 'Delete' | 'Custom'

export interface ActionsColumnProps {
  onActionSelected: (row: any, action: ColumnAction) => void
}

export const ActionsColumn = () => {}

export const getActionsColumn = (headerName: string) => {
  return {
    field: '',
    headerName: headerName,
    sortable: false,
    width: 200,
    disableClickEventBubbling: true, // Stop event propagation
    renderCell: (params: GridCellParams) => {
      return (
        <React.Fragment>
          <IconButton onClick={() => console.log('DD')}>
            <Details fontSize="small" />
          </IconButton>
        </React.Fragment>
      )
    },
  }
}
